import { table } from "console";
import "./DCReporting.css";
import { useState } from "react";
import { HEADER_LABELS } from "./dc-reporting-data";

type DCReportingProps = {
    data: any;
    isPreview: boolean;
    onCancel?: () => void;
    onSubmit?: () => void;
}

export const DCReporting = ({data, isPreview, onCancel, onSubmit} : DCReportingProps) => {

    const showLabel = (objectKey: string, propertyKey: string) => {
        if (objectKey.toLowerCase() === "employee-record") {
            switch (propertyKey.toLowerCase()) {
                case "id":
                    return false;
            }
        }

        return true;
    }

    const getLabel = (objectKey: string, propertyKey: string) => {
        
        if (Object.keys(HEADER_LABELS).includes(objectKey.toLowerCase())) {
            const labels = HEADER_LABELS[objectKey.toLowerCase() as keyof typeof HEADER_LABELS];

            if(Object.keys(labels).includes(propertyKey.toLowerCase())) {
                return labels[propertyKey.toLowerCase() as keyof typeof labels];
            }

        }

        return propertyKey;
    }
                
    
    const getDataType = (data: any) : "value" | "object" | "array" =>{
        if (typeof data !== "object") {
            return "value";
        }

        if (Array.isArray(data)) {
            return "array";
        }

        // if (Object.keys(data).length === 2 && Array.isArray(data[Object.keys(data)[0]])) {
        //     return "array";
        // }

        return "object";
    }

    console.log("[DCReporting] data: ", data);

    // 3 return types
    // not an object (just an answer like a name)
    // an object that is a single answer like an employee record
    // an object with a key that has an array

    let parsedData = {};

    try {
        parsedData = JSON.parse(data);
    } catch (e) {
        parsedData = data;
    }

    console.log("[DCReporting] parsedData: ", parsedData);
    console.log("[DCReporting] parsedData typeof: ", typeof parsedData);
    console.log("[DCReporting] parsedData array?: ", Array.isArray(parsedData));


    const dataType = getDataType(parsedData)

    console.log("[DCReporting] dataType: ", dataType);
    let tableKey = undefined;

    if (dataType === "array" ) {
        tableKey = Object.keys(parsedData)[0];
    }
    if (dataType === "object") {
        tableKey = "unnamed object";
    }

    const columns: string[] = [];
    const rowData: Map<string, any>[] = [];

    if (dataType === "object" && tableKey) {
        Object.keys(parsedData).forEach((key) => {
            columns.push(key);
        });

        const rowMap = new Map<string, any>();
        Object.keys(parsedData).forEach((key) => {
            rowMap.set(key, parsedData[key as keyof typeof parsedData]);
        });
        rowData.push(rowMap);
    }

    if (dataType === "array" && tableKey) {
        const dataArray = parsedData as any[];

        console.log("[DCReporting] dataArray: ", dataArray);
        console.log("[DCReporting] dataArray[0]: ", dataArray[0]);
        console.log("[DCReporting] dataArray.keys: ", Object.keys(dataArray[0]))

        // make column from keys of first object - assume uniformity
        if (dataArray.length > 0) {
            Object.keys(dataArray[0]).forEach((key) => {
                columns.push(key);
            })
        }

        // make rows from array of objects
        dataArray.forEach((row: any) => {
            const rowMap = new Map<string, any>();
            Object.keys(row).forEach((key) => {
                rowMap.set(key, row[key]);
            })
            rowData.push(rowMap);
        });
    }


    console.log("[DCReporting] tableKey: ", tableKey);
    console.log("[DCReporting] columns: ", columns);
    console.log("[DCReporting] rowData: ", rowData);   

    return (
        <div className={`dc-reporting ${isPreview ? "dc-reporting-preview" : ""}`}>
            {!tableKey && dataType === "value" &&
                <div className="dc-reporting-empty">
                    {data}
                </div>
            }
        
            {(dataType === "array" || dataType === "object") &&
                <>
                    {/* <div className="dc-reporting-header">
                        {tableKey}
                    </div> */}
                    <div className="dc-reporting-commentary">
                        {data?.commentary || ""}
                    </div>
                    <div className={isPreview ? "dc-reporting-body-preview" : "dc-reporting-body"}>
                        <div 
                            className="dc-reporting-grid"
                            style={{gridTemplateColumns: `repeat(${columns.filter(column => showLabel("employee-record", column)).length}, 1fr)`}}
                        >
                            {columns.filter(column => showLabel("employee-record", column)).map((column, index) => {
                                return (
                                    <div 
                                        key={index}
                                        className="dc-reporting-grid-header"
                                    >
                                        {getLabel("employee-record", column)}
                                    </div>
                                )
                            })}
                            {rowData.map((rowMap, index) => {
                                return (
                                    <>
                                        {columns.filter(column => showLabel("employee-record", column)).map((column, index) => {
                                            let cellData = rowMap.get(column);
                                            if (typeof cellData === "object") {
                                                cellData = JSON.stringify(cellData);
                                            }
                                            return (
                                                <div 
                                                    key={index}
                                                    className="dc-reporting-grid-item"
                                                >
                                                    {cellData}
                                                </div>
                                            )
                                        })}
                                    </>
                                )
                            })}
                        </div>
                    </div>
                </>
            }
        </div>
    )
}